<template>
  <section class="aidrama-box3">
    <!-- Pixso 6:615 part3 — 393×2094@1×；rem = @1× px × 2 -->
    <div class="aidrama-box3__inner">
      <header class="aidrama-box3__head">
        <h2 class="aidrama-box3__title">
          <span class="aidrama-box3__title-line aidrama-box3__title-line--accent"
            >匠心打磨AI漫剧课程</span
          >
          <span class="aidrama-box3__title-line">铸就核心竞争优势</span>
        </h2>
        <p class="aidrama-box3__sub">
          AIGC漫剧全流程创作，一人就是一支影视团队
        </p>
      </header>

      <div class="aidrama-box3__stages">
        <article
          v-for="stage in processStages"
          :key="stage.name"
          class="aidrama-box3-stage"
        >
          <div
            class="aidrama-box3-stage__head"
            :style="{ background: stage.headerBg }"
          >
            <h3 class="aidrama-box3-stage__head-title">{{ stage.name }}</h3>
          </div>
          <div
            class="aidrama-box3-stage__body"
            :class="`aidrama-box3-stage__body--${stage.layout}`"
          >
            <div
              v-for="card in stage.cards"
              :key="card.title"
              class="aidrama-box3-card"
              :class="[
                `aidrama-box3-card--${card.tone}`,
                { 'aidrama-box3-card--wide': card.wide, 'aidrama-box3-card--tall': card.tall },
              ]"
            >
              <h4 class="aidrama-box3-card__title">{{ card.title }}</h4>
              <p class="aidrama-box3-card__desc">{{ card.desc }}</p>
            </div>
          </div>
        </article>
      </div>

      <div class="aidrama-box3__syllabus">
        <div class="aidrama-box3__syllabus-label">课程大纲</div>
        <ul class="aidrama-box3__syllabus-list">
          <li
            v-for="(item, index) in syllabusItems"
            :key="item.title"
            class="aidrama-box3-syllabus-item"
          >
            <h4 class="aidrama-box3-syllabus-item__title">{{ item.title }}</h4>
            <p
              v-for="(line, lineIndex) in item.lines"
              :key="lineIndex"
              class="aidrama-box3-syllabus-item__line"
            >
              {{ line }}
            </p>
            <span
              v-if="index < syllabusItems.length - 1"
              class="aidrama-box3-syllabus-item__rule"
              aria-hidden="true"
            />
          </li>
        </ul>
      </div>

      <button type="button" class="aidrama-box3__cta" @click="handleCtaClick">
        <span class="aidrama-box3__cta-text">立即申请试学</span>
        <img class="aidrama-box3__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox3",
  data() {
    return {
      btnArrow: require("../../../assets/coursePage/aidrama/box3/btn_arrow.png"),
      processStages: [
        {
          name: "剧本开发阶段",
          headerBg: "linear-gradient(90deg, rgba(55, 143, 255, 1) 0%, rgba(47, 197, 255, 1) 100%)",
          layout: "two-tall",
          cards: [
            {
              title: "剧本开发",
              desc: "故事、人设、分集、对白；输出：大纲、人物小传、人物设定、分集剧本",
              tone: "blue",
              tall: true,
            },
            {
              title: "分镜脚本",
              desc: "拆解镜头；标注景别/运镜/台词；确定转场方式",
              tone: "blue",
              tall: true,
            },
          ],
        },
        {
          name: "创作前期",
          headerBg: "linear-gradient(90deg, rgba(39, 105, 255, 1) 0%, rgba(47, 145, 255, 1) 100%)",
          layout: "grid-four",
          cards: [
            { title: "资产筹备", desc: "角色资产；\n场景/道具/特效资产", tone: "blue" },
            { title: "统一画风", desc: "统一角色/场景；\n统一色调/光影", tone: "blue" },
            { title: "人物一致性修正", desc: "修正脸型/发型；\n服装/表情一致", tone: "blue" },
            { title: "角色声音设计", desc: "设计音色、语气、语速；\n设计情绪表达", tone: "blue" },
          ],
        },
        {
          name: "创作中期",
          headerBg: "linear-gradient(90deg, rgba(15, 80, 230, 1) 0%, rgba(15, 123, 241, 1) 100%)",
          layout: "two-wide",
          cards: [
            {
              title: "分镜制作",
              desc: "制作逐帧分镜；确定镜头画面；统一节奏基准",
              tone: "blue",
            },
            {
              title: "画面修正",
              desc: "修手、修脸；修穿帮、修构图；补充画面细节",
              tone: "blue",
            },
            {
              title: "画面统一",
              desc: "统一人物比例；统一场景透视；统一光影色彩",
              tone: "blue",
              wide: true,
            },
          ],
        },
        {
          name: "后期合成",
          headerBg: "linear-gradient(90deg, rgba(123, 49, 255, 1) 0%, rgba(121, 105, 255, 1) 100%)",
          layout: "grid-four-wide",
          cards: [
            {
              title: "视频生成",
              desc: "分镜图转动态视频；控制镜头运动/转场",
              tone: "purple",
            },
            {
              title: "语音生成",
              desc: "角色配音/旁白录制；情绪调整/语速匹配",
              tone: "purple",
            },
            {
              title: "视频剪辑",
              desc: "拼接镜头/匹配音画；调整节奏/卡点爽点",
              tone: "purple",
            },
            {
              title: "字幕制作",
              desc: "自动生成字幕/校对；调整样式/弹幕效果",
              tone: "purple",
            },
            {
              title: "音效与配乐",
              desc: "添加背景音效；匹配BGM/音量平衡",
              tone: "purple",
              wide: true,
            },
          ],
        },
        {
          name: "上线运营",
          headerBg: "linear-gradient(90deg, rgba(213, 105, 207, 1) 0%, rgba(251, 117, 44, 1) 100%)",
          layout: "two-wide",
          cards: [
            {
              title: "审核与发布",
              desc: "影片复审；多平台适配；上传发布",
              tone: "orange",
            },
            {
              title: "封面与标题",
              desc: "制作封面；标题/简介/标签",
              tone: "orange",
            },
            {
              title: "数据复盘",
              desc: "播放量/完播率；评论反馈；后续优化",
              tone: "orange",
              wide: true,
            },
          ],
        },
      ],
      syllabusItems: [
        {
          title: "01 视听语言基础+分镜头脚本认知",
          lines: [
            "景别/运镜/镜头逻辑分镜核心要素AI剧本转分镜实操",
            "识别基础视听语言独立设计分镜脚本用AI生成分镜图",
          ],
        },
        {
          title: "02 分镜头脚本优化+度加智能剪辑分镜导入",
          lines: [
            "分镜节奏优化原则度加分镜批量导入镜头时长标注",
            "优化分镜专业性完成分镜导入排序适配剪辑制作需求",
          ],
        },
        {
          title: "03 度加AI人物建模（精准化生成）",
          lines: [
            "人物生成参数调整风格统一技巧形象迭代优化",
            "生成贴合人设的人物保持系列形象统一筛选优质素材",
          ],
        },
        {
          title: "04 场景与道具物料生成（AI批量产出）",
          lines: [
            "场景/道具分类原则AI批量生成技巧素材库搭建",
            "快速生成全场景素材搭建风格统一素材包",
          ],
        },
        {
          title: "05 AI抽卡技巧（人物/场景精准抽取）",
          lines: [
            "AI抽卡核心逻辑风格锁定方法不满意素材优化",
            "精准抽取所需素材解决风格混乱问题提升素材质量",
          ],
        },
        {
          title: "06 音乐音效素材获取（版权合规版）",
          lines: [
            "漫剧音效分类版权合规渠道AI适配音效实操",
            "获取合规音乐音效匹配剧情情绪需求整理专属音效包",
          ],
        },
        {
          title: "07 AI配音技巧（度加AI语音定制）",
          lines: [
            "配音参数调整（音色/语速/情感）人设适配技巧配音优化",
            "生成贴合人设的配音调整配音节奏完成全剧配音制作",
          ],
        },
      ],
    };
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第3屏-立即申请试学", {
          终端: "H5",
          名称: "传智AI漫剧页-第3屏-立即申请试学",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box3 {
  width: 100%;
  box-sizing: border-box;
}

.aidrama-box3__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 80px 20px 80px;
  box-sizing: border-box;
}

/* 6:616 gap 6px */
.aidrama-box3__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box3__title {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.aidrama-box3__title-line {
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(47, 52, 59, 1);
  white-space: nowrap;
}

.aidrama-box3__title-line--accent {
  color: rgba(39, 101, 255, 1);
}

.aidrama-box3__sub {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 6:619 — 350×296 */
.aidrama-box3__illus {
  display: block;
  width: 700px;
  max-width: 100%;
  height: auto;
  margin-top: 26px;
  box-sizing: border-box;
}

/* 6:623 — 373 宽；阶段间距 10 */
.aidrama-box3__stages {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 26px;
  box-sizing: border-box;
}

.aidrama-box3-stage {
  width: 100%;
  box-sizing: border-box;
  border-radius: 24px;
  overflow: hidden;
}

.aidrama-box3-stage__head {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
  padding: 0 20px;
  box-sizing: border-box;
}

.aidrama-box3-stage__head-title {
  margin: 0;
  font-size: 28px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box3-stage__body {
  display: grid;
  gap: 20px;
  padding: 20px 0;
  box-sizing: border-box;
  background: rgba(241, 249, 254, 1);
}

.aidrama-box3-stage__body--two-tall {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;
  padding-left: 23px;
  padding-right: 23px;
}

.aidrama-box3-stage__body--grid-four {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;
  padding-left: 23px;
  padding-right: 23px;
}

.aidrama-box3-stage__body--two-wide {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;
  padding-left: 23px;
  padding-right: 23px;
}

.aidrama-box3-stage__body--grid-four-wide {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-content: center;
  padding-left: 23px;
  padding-right: 23px;
}

.aidrama-box3-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  padding: 12px 20px;
  box-sizing: border-box;
  border-radius: 16px;
  background: #fff;
  text-align: center;
}

.aidrama-box3-card--tall {
  min-height: 210px;
}

.aidrama-box3-card:not(.aidrama-box3-card--tall):not(.aidrama-box3-card--wide) {
  min-height: 160px;
}

.aidrama-box3-card--wide {
  grid-column: 1 / -1;
  width: 100%;
  min-height: 128px;
}

.aidrama-box3-card__title {
  margin: 0;
  font-size: 28px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  white-space: nowrap;
}

.aidrama-box3-card--blue .aidrama-box3-card__title {
  color: rgba(39, 101, 255, 1);
}

.aidrama-box3-card--purple .aidrama-box3-card__title {
  color: rgba(143, 97, 250, 1);
}

.aidrama-box3-card--orange .aidrama-box3-card__title {
  color: rgba(255, 120, 68, 1);
}

.aidrama-box3-card__desc {
  margin: 0;
  font-size: 24px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 2px;
  color: rgba(83, 83, 83, 1);
  white-space: pre-line;
}

/* 6:695 — 373×682 */
.aidrama-box3__syllabus {
  width: 100%;
  margin-top: 56px;
  padding: 48px 70px 48px;
  box-sizing: border-box;
  border-radius: 24px;
  background: linear-gradient(
    225deg,
    rgba(0, 129, 255, 1) 0%,
    rgba(2, 122, 255, 1) 99%
  );
}

.aidrama-box3__syllabus-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 84px;
  margin-bottom: 20px;
  padding: 8px 20px;
  box-sizing: border-box;
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 52px;
  letter-spacing: 2px;
  color: rgba(87, 255, 245, 1);
  white-space: nowrap;
  background: linear-gradient(
    90deg,
    rgba(49, 179, 255, 1) 0%,
    rgba(49, 179, 255, 0) 100%
  );
}

.aidrama-box3__syllabus-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
}

.aidrama-box3-syllabus-item {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
}

.aidrama-box3-syllabus-item__title {
  margin: 0;
  font-size: 26px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 2px;
  color: #fff;
}

.aidrama-box3-syllabus-item__line {
  margin: 0;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 2px;
  color: #fff;
}

.aidrama-box3-syllabus-item__rule {
  display: block;
  width: 100%;
  height: 1px;
  margin-top: 8px;
  background: rgba(31, 179, 255, 1);
}

/* 6:620 */
.aidrama-box3__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 40px;
  padding: 40px 60px 40px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box3__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box3__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
